import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'react-router-dom';
import UIButton from 'UIComponents/button/UIButton';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H1, H4, H7 } from 'UIComponents/elements/headings';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import styled, { theme } from '../../../components/Theme';
import { FilterQuery } from '../../../consts';
import { useMediaQuery } from '../../../utils/hooks';
import { hubspotEditPagePaths } from '../../../utils/urls';
import AvatarViewer from '../../avatar/components/AvatarViewer';
import { useIsCurrentUser, useUserByUsername } from '../userQueries';
const Card = styled(UICardWrapper).withConfig({
  displayName: "HeroCard__Card",
  componentId: "yir3x7-0"
})(["padding:32px 24px;margin-bottom:0 !important;box-shadow:0 8px 16px rgb(51 71 91 / 30%);"]);
const HeroCardWrapper = styled(Card).withConfig({
  displayName: "HeroCard__HeroCardWrapper",
  componentId: "yir3x7-1"
})(["display:flex;flex-direction:row;width:100%;@media (max-width:", "){flex-direction:column;}"], props => props.theme.sizes.GRID_BREAKPOINT_SMALL);

const HeroCard = ({
  username
}) => {
  const {
    user
  } = useUserByUsername(username);
  const screenLarge = useMediaQuery(`(min-width: ${theme.sizes.GRID_BREAKPOINT_SMALL})`);
  const showEdit = useIsCurrentUser(user ? user.userId : undefined);
  const {
    displayName,
    company,
    jobTitle,
    biography,
    createdAt,
    geolocation,
    industry,
    pronouns,
    avatarHash,
    avatarLastUpdated
  } = user || {};

  const companyLink = company && /*#__PURE__*/_jsx(Link, {
    to: `/?${FilterQuery.company}=${JSON.stringify(company)}`,
    children: company.name
  });

  return /*#__PURE__*/_jsxs(HeroCardWrapper, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-right-4",
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        lastUpdated: avatarLastUpdated
      })
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        className: "m-bottom-4",
        justify: "between",
        align: "center",
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(H1, {
            style: {
              display: 'inline-block',
              marginBottom: 0,
              marginRight: 8
            },
            children: displayName
          }), /*#__PURE__*/_jsx(H4, {
            style: {
              display: 'inline-block',
              marginBottom: 0
            },
            children: pronouns
          })]
        }), showEdit && screenLarge && /*#__PURE__*/_jsx(UIButton, {
          href: hubspotEditPagePaths.edit(),
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.edit"
          })
        })]
      }), /*#__PURE__*/_jsx(H7, {
        className: "m-bottom-4",
        children: company && jobTitle ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "connectDotCom.profile.roleAtCompany",
          options: {
            jobTitle,
            companyName: companyLink
          }
        }) : company ? companyLink : jobTitle
      }), /*#__PURE__*/_jsx("p", {
        "data-test-id": "biography",
        className: "m-bottom-4",
        children: biography || showEdit && /*#__PURE__*/_jsx("i", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.profile.biographyPlaceholder"
          })
        })
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsxs(UIList, {
          inline: true,
          use: "inline-divided",
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "connectDotCom.profile.memberSince",
            options: {
              date: /*#__PURE__*/_jsx(FormattedDateTime, {
                value: createdAt,
                format: "MMMM YYYY"
              })
            }
          }), geolocation && geolocation.displayName, industry && /*#__PURE__*/_jsx(Link, {
            to: `/?${FilterQuery.industry}=${JSON.stringify(industry)}`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "connectDotCom.profile.nameOfIndustry",
              options: {
                name: industry.name
              }
            })
          })]
        })
      }), showEdit && !screenLarge && /*#__PURE__*/_jsx(UIButton, {
        className: "m-top-2",
        href: hubspotEditPagePaths.edit(),
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.edit"
        })
      })]
    })]
  });
};

export default HeroCard;